const Hero = () => {
  return (
    <section className='hero' id='home'>
      <div className='hero-banner'>
        <h1>Guangyao's Portfolio</h1>
        <p>
          Crafting immersive Web experiences with Fullstack Web Technologies, including React, Next.js, Typescript, TailwindCSS, Node.js, Express, firebase, MongoDB, and more.
        </p>
        <a href='#projects' className='btn hero-btn '>
          Explore My Work
        </a>
      </div>
    </section>
  )
}
export default Hero
